import { render } from "./AdvertStat.vue?vue&type=template&id=f13ef00c"
import script from "./AdvertStat.vue?vue&type=script&lang=js"
export * from "./AdvertStat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__